import React, {useEffect} from 'react';
import {ReactComponent as BackIcon} from '../../../../assets/main/groups/main-top/back.svg';
import {MainTop} from './main-top/Main-top';
import {MainTable} from './main-table/MainTable';
import {Students} from './students/Students';
import {
    StudentsTimetable
} from "components/pages/groups/group-container/students/students-pages/students-timetable/StudentsTimetable";
import {useAppDispatch, useAppSelector} from "common/hook";
import AuthWrapper from "../../../auth-wrapper/AuthWrapper";
import {Skeleton} from "antd";
import {fetchCalendar} from "features/model/service/calendar/calendar";
import {useParams} from "react-router-dom";

export const GroupsContainer = () => {
    const activeTabs = useAppSelector((state) => state.topTabs.activeTabs);
    const groupsState = useAppSelector((state) => state.groupsLessons.group);
    const title = groupsState.title || <Skeleton.Input active={true}/>;


    // const dispatch = useAppDispatch()
    // const calendarData = useAppSelector(state => state.calendar)
    // const {groupId} = useParams()
    //
    //
    // useEffect(() => {
    //     console.log(calendarData, 'calendarData')
    //     if (groupId && !calendarData.authUrl) {
    //         dispatch(fetchCalendar({groupId}));
    //     }
    // }, []);




    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop
                    title={title}
                    tabs={true}
                    setting={true}
                    link={'/groups'}
                    icons={<BackIcon/>}
                />
                {activeTabs.includes(0) && <MainTable/>}
                {activeTabs.includes(1) && <StudentsTimetable/>}
                {activeTabs.includes(2) && <Students/>}
            </div>
        </AuthWrapper>
    );

};


